import { render, staticRenderFns } from "./ModalPage.vue?vue&type=template&id=c02f6566&scoped=true&"
import script from "./ModalPage.vue?vue&type=script&lang=js&"
export * from "./ModalPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalPage.vue?vue&type=style&index=0&id=c02f6566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02f6566",
  null
  
)

export default component.exports